import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';
import { IconButton, Typography } from '@mui/material';
import WhatsappOutlinedIcon from '@mui/icons-material/WhatsappOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import analytics from '../../utils/analytics';

type ShareButtonsProps = {
    shareText: string,
    url: string,
    whatsapp?: boolean,
    facebook?:boolean,
    twitter?:boolean,
    sms?:boolean,
    email?:boolean,
    telegram?:boolean,
    linkedin?:boolean
}

export default function ShareButtons(props:ShareButtonsProps) {
  const {
    shareText,
    url,
    whatsapp,
    facebook,
    twitter,
    sms,
    email,
    telegram,
    linkedin,
  } = props;

  const handleClick = (rrss:string) => {
    analytics.track('Click Boton', { text: `Compartir mediante ${rrss}`, initiator: 'usuario' });
  };

  const objectEncode = (object: Record<string, string>) => {
    const str: string[] = [];
    Object.keys(object).forEach((key) => {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`);
    });
    return str.join('&');
  };

  return (
    <div style={{ textAlign: 'center', paddingBlock: 5 }}>
      {whatsapp
      && (
      <WhatsappShareButton
        title={shareText}
        url={url}
        onClick={() => handleClick('Whatsapp')}
        style={{ display: 'inline-grid' }}
      >
        <IconButton style={{ padding: '0px 10px' }} component="div">
          <WhatsappOutlinedIcon
            fontSize="large"
            style={{ color: 'green' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">Whatsapp</Typography>
      </WhatsappShareButton>
      )}
      {facebook
      && (
      <FacebookShareButton title={shareText} url={url} onClick={() => handleClick('Facebook')} style={{ display: 'inline-grid' }}>
        <IconButton style={{ padding: '0px 10px' }} component="div">
          <FacebookIcon
            fontSize="large"
            style={{ color: '#3b5998' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">Facebook</Typography>
      </FacebookShareButton>
      )}
      {twitter
      && (
      <TwitterShareButton title={shareText} url={url} onClick={() => handleClick('X')} style={{ display: 'inline-grid' }}>
        <IconButton style={{ padding: '0px 10px' }} component="div">
          <TwitterIcon
            fontSize="large"
            style={{ color: '#00acee' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">X</Typography>
      </TwitterShareButton>
      )}
      {sms
      && (
      <a
        href={`sms:?&${objectEncode({ body: `${shareText} ${url}` })}`}
        onClick={() => handleClick('SMS')}
        style={{ display: 'inline-grid', textDecoration: 'none' }}
      >
        <IconButton style={{ padding: '0px 10px' }}>
          <SmsIcon
            fontSize="large"
            style={{ color: '#0088cc' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">SMS</Typography>
      </a>
      )}
      {email
      && (
        <EmailShareButton
          url={url}
          subject="Postula a un crédito con banca.me"
          body={shareText}
          onClick={() => handleClick('Email')}
          style={{ display: 'inline-grid', textDecoration: 'none' }}
        >
          <IconButton style={{ padding: '0px 10px' }} component="div">
            <EmailIcon fontSize="large" style={{ color: 'grey' }} />
          </IconButton>
          <Typography variant="caption" align="center" fontSize="10px">Email</Typography>
        </EmailShareButton>
      )}
      {telegram
      && (
      <TelegramShareButton title={shareText} url={url} onClick={() => handleClick('Telegram')} style={{ display: 'inline-grid' }}>
        <IconButton style={{ padding: '0px 10px' }} component="div">
          <TelegramIcon
            fontSize="large"
            style={{ color: '#0088cc' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">Telegram</Typography>
      </TelegramShareButton>
      )}
      {linkedin
      && (
      <LinkedinShareButton title={shareText} url={url} onClick={() => handleClick('Linkedin')} style={{ display: 'inline-grid' }}>
        <IconButton style={{ padding: '0px 10px' }} component="div">
          <LinkedInIcon
            fontSize="large"
            style={{ color: '#0088cc' }}
          />
        </IconButton>
        <Typography variant="caption" align="center" fontSize="10px">Linkedin</Typography>
      </LinkedinShareButton>
      )}
    </div>
  );
}
ShareButtons.defaultProps = {
  whatsapp: true,
  facebook: true,
  twitter: true,
  sms: true,
  email: true,
  telegram: true,
  linkedin: true,
};
